var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.25,
    height: 24.595,
    viewBox: "0 0 28.25 24.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ticket",
    transform: "translate(-10.42 -41.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.42 41.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M381.142,172.8a.661.661,0,0,0,.614-.614V168.5a1.809,1.809,0,0,0-1.842-1.842H375v17.2h4.913a1.809,1.809,0,0,0,1.842-1.842v-3.685a.616.616,0,0,0-.614-.614,2.457,2.457,0,1,1,0-4.913Z",
    transform: "translate(-353.505 -159.261)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M142.515,46.724a.639.639,0,0,0,.368-.8l-1.229-3.5a1.857,1.857,0,0,0-2.334-1.167L121.88,47.277h19.652a3.114,3.114,0,0,1,.983-.552Z",
    transform: "translate(-115.309 -41.167)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.42,168.512V172.2a.581.581,0,0,0,.614.614,2.457,2.457,0,1,1,0,4.913.58.58,0,0,0-.614.614v3.685a1.809,1.809,0,0,0,1.842,1.842H30.687v-17.2H12.262a1.811,1.811,0,0,0-1.842,1.842Zm7.37,3.07h3.685a.614.614,0,0,1,0,1.229H17.79a.614.614,0,0,1,0-1.229Zm0,3.07h7.983a.614.614,0,0,1,0,1.229H17.79a.614.614,0,1,1,0-1.229Zm0,3.07h7.983a.614.614,0,0,1,0,1.229H17.79a.614.614,0,1,1,0-1.228Z",
    transform: "translate(-10.42 -159.271)",
    fill: "#5b5b5b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticketIcon.5c67f70243b92932e560b96efb23d8d3.svg";
export { ForwardRef as ReactComponent };